import type { IVariantType } from '~/modules/campaign';
import type { IMakeWinnerMetadata } from '../types';

import { EMakeWinnerStep } from '../types';
import { create } from 'zustand';

export interface ISelectedPagesData {
  pages: string[];
  isMakeDefault: boolean;
  blog?: { baseID: string; handle: string };
  page?: { handle: string; title: string };
}

export interface IMakeWinnerState {
  selectedVariant: IVariantType | null;
  tempSelectedVariant: IVariantType | null;
  selectedPagesData: ISelectedPagesData;
  makeWinnerStep: EMakeWinnerStep;
  makeWinnerMetadata: IMakeWinnerMetadata | null;
  hasWinner: boolean;
  isMakingWinner: boolean;
}

export interface IMakeWinnerActions {
  setMakeWinnerMetadata: (metadata: IMakeWinnerMetadata | null) => void;
  setMakeWinnerStep: (step: EMakeWinnerStep) => void;
  setSelectedVariant: (variant: IVariantType | null) => void;
  asyncSelectedVariant: () => void;
  setTempSelectedVariant: (variant: IVariantType | null) => void;
  setSelectedPagesData: (data: ISelectedPagesData) => void;
  resetSelectedPagesData: () => void;
  resetData: () => void;
  setHasWinner: (hasWinner: boolean) => void;
  setIsMakingWinner: (isMakingWinner: boolean) => void;
}

export type IMakeWinnerStore = IMakeWinnerState & IMakeWinnerActions;

const INITIAL_SELECTED_PAGES_DATA: ISelectedPagesData = {
  pages: [],
  isMakeDefault: false,
};

const INITIAL_STATE: IMakeWinnerState = {
  selectedVariant: null,
  tempSelectedVariant: null,
  selectedPagesData: INITIAL_SELECTED_PAGES_DATA,
  makeWinnerStep: EMakeWinnerStep.NONE,
  makeWinnerMetadata: null,
  hasWinner: false,
  isMakingWinner: false,
};

export const useMakeWinnerStore = create<IMakeWinnerStore>((set) => ({
  ...INITIAL_STATE,
  setMakeWinnerMetadata: (metadata) => {
    set({ makeWinnerMetadata: metadata, selectedPagesData: INITIAL_SELECTED_PAGES_DATA });
  },
  setMakeWinnerStep: (step) => {
    set({ makeWinnerStep: step });
  },
  setSelectedVariant: (variant) => {
    set({ selectedVariant: variant });
  },
  asyncSelectedVariant: () => {
    set((state) => {
      return {
        selectedVariant: state.tempSelectedVariant,
      };
    });
  },
  setTempSelectedVariant: (variant) => {
    set({ tempSelectedVariant: variant });
  },
  setSelectedPagesData: (data) => {
    set({ selectedPagesData: data });
  },
  resetSelectedPagesData: () => {
    set({ selectedPagesData: INITIAL_SELECTED_PAGES_DATA });
  },
  resetData: () => {
    set({
      ...INITIAL_STATE,
    });
  },
  setHasWinner: (hasWinner) => {
    set({ hasWinner });
  },
  setIsMakingWinner: (isMakingWinner) => {
    set({ isMakingWinner });
  },
}));
